module.exports = __webpack_public_path__ + "static/media/logo--white.5bf6d0ac.svg";